import axios from 'axios';

import { 
        CONFIGURACION_PERFIL, 
        CONFIGURACION_CATEGORIAS,
        CONFIGURACION_SUBCATEGORIAS, 
        CONFIGURACION_PRODUCTOS, 
        CONFIGURACION_AREAS,
        CONFIGURACION_ORGANIZADORES, 
        CONFIGURACION_UBICACIONES, 
        CONFIGURACION_PROVEEDORES_PRODUCTO,
        CONFIGURACION_UNIDADES,
        CONFIGURACION_METODOS_PAGO,
        CONFIGURACION_PAQUETES
    } from '../actions/types';

import { setAlert } from './alert';
import { changeLoader } from './loader';

//Métodos de pago
export const listarMetodosPago = () => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    try {
        await dispatch(changeLoader(true));
        const res = await axios.get(`${process.env.REACT_APP_API_ROUTE}/configuracion/listar_metodos`, config);
        await dispatch(changeLoader(false));

        await dispatch({
            type: CONFIGURACION_METODOS_PAGO.BUSCAR,
            payload: res.data.metodos
        });
    } catch (error) {
        await dispatch(changeLoader(false));

        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    }
};

export const crearMetodoPago = (data) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/configuracion/crear_metodo`,
            {
                nombre: data?.nombre ? String(data.nombre).trim() : '',
                tipo: 1,
                descripcion: data?.descripcion ? String(data.descripcion).trim() : ''
            },
            config
        );
        await dispatch(changeLoader(false));

        await dispatch({
            type: CONFIGURACION_METODOS_PAGO.AGREGAR,
            payload: res.data.metodo
        });

        if (res?.data?.msg) {
            await dispatch(setAlert(res.data.msg, 'success'));
        }
        return true;
    } catch (error) {
        await dispatch(changeLoader(false));

        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
        return false;
    }
};

export const detallesMetodoPago = (id) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/configuracion/detalles_metodo`,
            { id: String(id) },
            config
        );
        await dispatch(changeLoader(false));

        await dispatch({
            type: CONFIGURACION_METODOS_PAGO.DETALLES,
            payload: res.data.metodo
        });

        return true;
    } catch (error) {
        await dispatch(changeLoader(false));

        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
        return false;
    }
};

export const editarMetodoPago = (data) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/configuracion/editar_metodo`,
            {
                id: data?.id ? String(data.id) : '',
                nombre: data?.nombre ? String(data.nombre).trim() : '',
                descripcion: data?.descripcion ? String(data.descripcion).trim() : '',
                tipo: 1
            },
            config
        );
        await dispatch(changeLoader(false));

        await dispatch({
            type: CONFIGURACION_METODOS_PAGO.EDITAR,
            payload: res.data.metodo
        });

        if (res?.data?.msg) {
            await dispatch(setAlert(res.data.msg, 'success'));
        }
        return true;
    } catch (error) {
        await dispatch(changeLoader(false));

        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
        return false;
    }
};

export const eliminarMetodoPago = (id) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/configuracion/eliminar_metodo`,
            { id: String(id) },
            config
        );
        await dispatch(changeLoader(false));

        if (res?.data?.success) {
            await dispatch({
                type: CONFIGURACION_METODOS_PAGO.ELIMINAR,
                payload: String(id)
            });

            if (res?.data?.msg) {
                await dispatch(setAlert(res.data.msg, 'success'));
            }
            return true;
        }

        if (res?.data?.msg) {
            await dispatch(setAlert(res.data.msg, 'danger'));
        }
        return false;
    } catch (error) {
        await dispatch(changeLoader(false));

        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
        return false;
    }
};

/* Perfil */
export const guardarPerfil = (perfil) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    }

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/configuracion/editar_perfil_personal`, perfil, config);

        await dispatch({
            type: CONFIGURACION_PERFIL.EDITAR_PERSONAL,
            payload: res.data.perfil
        });

        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error) {
        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
}

//Categorias
export const buscarCategoriasConfiguracion = () => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    try{
        await dispatch(changeLoader(true));
        const res = await axios.get(`${process.env.REACT_APP_API_ROUTE}/configuracion/listar_categorias`, config);
        await dispatch(changeLoader(false));

        await dispatch({
            type: CONFIGURACION_CATEGORIAS.BUSCAR,
            payload: res.data.categorias
        });
    } catch (error){ 
        await await dispatch(changeLoader(false));

        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    }
}

export const crearCategoriaConfiguracion = (categoria) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    
    const body = JSON.stringify(categoria);

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/configuracion/crear_categoria`, body, config);
        await dispatch(changeLoader(false));

        await dispatch({
            type: CONFIGURACION_CATEGORIAS.AGREGAR,
            payload: res.data.categoria
        });

        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error){
        await dispatch(changeLoader(false));
        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    }
}

export const obtenerCategoriaConfiguracion = (id) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    
    const body = {
        id
    };

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/configuracion/detalles_categoria`, body, config);
        await dispatch(changeLoader(false));

        await dispatch({
            type: CONFIGURACION_CATEGORIAS.DETALLES,
            payload: res.data.categoria
        });
    } catch (error){
        await dispatch(changeLoader(false));
        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    }
}

export const limpiarCategoriaConfiguracion = () => dispatch => {
    dispatch({
        type: CONFIGURACION_CATEGORIAS.DETALLES,
        payload: null
    });
}

export const editarCategoriaConfiguracion = (categoria) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
        },
    };

    // Front usa _id, back espera id
    const body = JSON.stringify({
        ...categoria,
        id: categoria._id, // clave para que el back no truene
    });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/configuracion/editar_categoria`,
            body,
            config
        );
        await dispatch(changeLoader(false));

        await dispatch({
            type: CONFIGURACION_CATEGORIAS.EDITAR,
            payload: res.data.categoria, // ya viene con _id
        });

        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error) {
        await dispatch(changeLoader(false));
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    }
};


export const eliminarCategoriaConfiguracion = (categoria) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
        },
    };

    const body = JSON.stringify({
        ...categoria,
        id: categoria._id, // lo que el back necesita
    });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/configuracion/eliminar_categoria`,
            body,
            config
        );
        await dispatch(changeLoader(false));

        await dispatch({
            type: CONFIGURACION_CATEGORIAS.ELIMINAR,
            payload: { _id: categoria._id },
        });

        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error) {
        await dispatch(changeLoader(false));
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    }
};


//Subcategorias
export const buscarSubcategoriasConfiguracion = (id) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    const body = {
        id
    };

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/configuracion/listar_subcategorias`, body, config);
        await dispatch(changeLoader(false));

        await dispatch({
            type: CONFIGURACION_SUBCATEGORIAS.BUSCAR,
            payload: res.data.subcategorias
        });
    } catch (error){ 
        await await dispatch(changeLoader(false));

        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    }
}

export const crearSubcategoriaConfiguracion = (subcategoria) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    
    const body = JSON.stringify(subcategoria);

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/configuracion/crear_subcategoria`, body, config);
        await dispatch(changeLoader(false));

        if(subcategoria.categoria){
            await dispatch({
                type: CONFIGURACION_SUBCATEGORIAS.AGREGAR,
                payload: res.data.subcategoria
            });
        }

        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error){
        await dispatch(changeLoader(false));
        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    }
}

export const obtenerSubcategoriaConfiguracion = (_id) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
        },
    };

    // Mandamos tanto id como _id por si el back usa uno u otro
    const body = {
        id: _id,   // <- lo que casi seguro está validando el backend
        _id: _id,
    };

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/configuracion/detalles_subcategoria`,
            body,
            config
        );
        await dispatch(changeLoader(false));

        await dispatch({
            type: CONFIGURACION_SUBCATEGORIAS.DETALLES,
            payload: res.data.subcategoria,
        });
    } catch (error) {
        await dispatch(changeLoader(false));
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    }
};


export const limpiarSubcategoriaConfiguracion = () => dispatch => {
    dispatch({
        type: CONFIGURACION_SUBCATEGORIAS.DETALLES,
        payload: null
    });
}

export const editarSubcategoriaConfiguracion = (subcategoria) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
        },
    };

    // El front usa _id, el back casi seguro espera id
    const body = JSON.stringify({
        id: subcategoria._id,           // id de la subcategoría
        id_categoria: subcategoria.id_categoria, // id de la categoría
        nombre: subcategoria.nombre,
        descripcion: subcategoria.descripcion,
    });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/configuracion/editar_subcategoria`,
            body,
            config
        );
        await dispatch(changeLoader(false));

        if (subcategoria.categoria) {
            await dispatch({
                type: CONFIGURACION_SUBCATEGORIAS.EDITAR,
                payload: res.data.subcategoria,
            });
        } else {
            await dispatch({
                type: CONFIGURACION_SUBCATEGORIAS.ELIMINAR,
                payload: subcategoria,
            });
        }

        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error) {
        await dispatch(changeLoader(false));
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    }
};


export const eliminarSubcategoriaConfiguracion = (id) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    
    const body = {
        id
    };

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/configuracion/eliminar_subcategoria`, body, config);
        await dispatch(changeLoader(false));

        await dispatch({
            type: CONFIGURACION_SUBCATEGORIAS.ELIMINAR,
            payload: body
        });
        
        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error){ 
        await dispatch(changeLoader(false));
        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    }
}


//Productos
    export const filtarProductosConfiguracion = (opcion) => dispatch => {
        dispatch({
            type: CONFIGURACION_PRODUCTOS.FILTROS,
            payload: opcion
        });
    }

    export const buscarProductosConfiguracion = (filtros = {}) => async dispatch => {
        const config = {
            headers: {
                'Content-Type': 'application/json'
            }
        };
        const bodyBack = {
            nombre: filtros.nombre ?? null,
            id_categoria: filtros.id_categoria ?? filtros.categoria ?? null,
            id_subcategoria: filtros.id_subcategoria ?? filtros.subcategoria ?? null,
            codigo: filtros.codigo ?? filtros.codigo_barras ?? null,
            codigo_proveedor: filtros.codigo_proveedor ?? filtros.codigoProveedor ?? null
        };

        const body = JSON.stringify(bodyBack);

        try{
            await dispatch(changeLoader(true));
            const res = await axios.post(
                `${process.env.REACT_APP_API_ROUTE}/configuracion/listar_productos`,
                body,
                config
            );
            await dispatch(changeLoader(false));

            await dispatch({
                type: CONFIGURACION_PRODUCTOS.BUSCAR,
                payload: res.data.productos
            });
        } catch (error){ 
            await dispatch(changeLoader(false));

            if(error?.response?.data?.msg) {
                await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
            }
        }
    };

    export const limpiarProductosConfiguracion = () => async dispatch => {
        await dispatch({
            type: CONFIGURACION_PRODUCTOS.BUSCAR,
            payload: []
        });
    };

    export const crearProductoConfiguracion = (producto) => async dispatch => {
        const config = {
            headers: {
                'Content-Type': 'application/json'
            }
        };

        const body = JSON.stringify({
            nombre:          producto.nombre,
            descripcion:     producto.descripcion,
            id_categoria:    producto.id_categoria ?? null,
            id_subcategoria: producto.id_subcategoria ?? null,
            codigo:          producto.codigo,
            unidades:        Array.isArray(producto.unidades) ? producto.unidades : []
        });

        try {
            const res = await axios.post(
                `${process.env.REACT_APP_API_ROUTE}/configuracion/crear_producto`,
                body,
                config
            );

            await dispatch(buscarProductosConfiguracion({
                nombre: null,
                id_categoria: null,
                id_subcategoria: null,
                codigo: null,
            }));

            await dispatch(setAlert(res.data.msg, 'success'));
        } catch (error) {
            if (error?.response?.data?.msg) {
                await dispatch(setAlert(error.response.data.msg, 'danger'));
            }
        }
    };

    export const obtenerProductoConfiguracion = (id) => async dispatch => {
        const config = {
            headers: {
                'Content-Type': 'application/json'
            }
        }
        
        const body = {
            id
        };

        try{
            const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/configuracion/detalles_producto`, body, config);

            await dispatch({
                type: CONFIGURACION_PRODUCTOS.DETALLES,
                payload: res.data.producto
            });
        } catch (error){         
            if(error?.response?.data?.msg) {
                await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
            }
        }
    }

    export const limpiarProductoConfiguracion = () => dispatch => {
        dispatch({
            type: CONFIGURACION_PRODUCTOS.DETALLES,
            payload: null
        });
    }

    export const editarProductoConfiguracion = (producto) => async dispatch => {
        const config = {
            headers: { 'Content-Type': 'application/json' }
        };

        const body = JSON.stringify(producto);

        try {
            const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/configuracion/editar_producto`,
            body,
            config
            );

            // 1) Alert SIEMPRE
            await dispatch(setAlert(res.data.msg || 'Producto editado correctamente', 'success'));

            // 2) Si el backend regresa el producto, actualiza el store en caliente
            if (res?.data?.producto?._id) {
            await dispatch({
                type: CONFIGURACION_PRODUCTOS.EDITAR,
                payload: res.data.producto
            });
            } else {
            // 3) Si NO regresa producto, refrescamos listado (tu backend ya guardó)
            await dispatch(buscarProductosConfiguracion({
                nombre: null,
                id_categoria: null,
                id_subcategoria: null,
                codigo: null
            }));

            // Opcional: refrescar detalles también, por si hay pantallas que dependan
            if (producto?.id || producto?._id) {
                await dispatch(obtenerProductoConfiguracion(producto.id || producto._id));
            }
            }
        } catch (error) {
            if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
            }
        }
    };


    export const eliminarProductoConfiguracion = (id) => async dispatch => {
        const config = {
            headers: {
                'Content-Type': 'application/json'
            }
        };
        
        const body = { id }; 

        try {
            const res = await axios.post(
                `${process.env.REACT_APP_API_ROUTE}/configuracion/eliminar_producto`,
                body,
                config
            );

            await dispatch({
                type: CONFIGURACION_PRODUCTOS.ELIMINAR,
                payload: { _id: id }   
            });
            
            await dispatch(setAlert(res.data.msg, 'success'));
        } catch (error){ 
            if(error?.response?.data?.msg) {
                await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
            }
        }
    };

    export const eliminarProductosConfiguracion = (ids) => async dispatch => {
        const config = {
            headers: {
                'Content-Type': 'application/json'
            }
        }
        
        const body = {
            ids
        };

        try{
            const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/configuracion/eliminar_productos`, body, config);

            await dispatch({
                type: CONFIGURACION_PRODUCTOS.ELIMINAR_MULTIPLE,
                payload: ids
            });
            
            await dispatch(setAlert(res.data.msg, 'success'));
        } catch (error){ 
            if(error?.response?.data?.msg) {
                await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
            }
        }
    }

    export const editarProductosConfiguracion = (data) => async dispatch => {
        const config = { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } };
        const body = new URLSearchParams();

        data.ids_producto.forEach(id => body.append('ids_producto[]', id));
        body.append('id_categoria', data.id_categoria);

        body.append(
            'id_subcategoria',
            data.id_subcategoria !== null && data.id_subcategoria !== undefined ? data.id_subcategoria : ''
        );

        const unidades = Array.isArray(data.unidades) ? data.unidades : [];
        if (unidades.length === 0) {
            body.append('unidades', '[]');
        } else {
            for (let i = 0; i < unidades.length; i++) {
                body.append(`unidades[${i}][id_unidad]`, unidades[i]?.id_unidad ? String(unidades[i].id_unidad) : '');
                body.append(`unidades[${i}][tipo]`, unidades[i]?.tipo !== '' && unidades[i]?.tipo !== null && unidades[i]?.tipo !== undefined ? String(unidades[i].tipo) : '');
                body.append(`unidades[${i}][cantidad]`, unidades[i]?.cantidad !== '' && unidades[i]?.cantidad !== null && unidades[i]?.cantidad !== undefined ? String(unidades[i].cantidad) : '');
            }
        }

        try {
            await dispatch(changeLoader(true));

            const res = await axios.post(
                `${process.env.REACT_APP_API_ROUTE}/configuracion/editar_productos`,
                body,
                config
            );

            const ok = res?.data?.success === true;

            await dispatch(setAlert(res.data.msg || 'Productos editados correctamente', ok ? 'success' : 'danger'));

            if (ok) {
                await dispatch(
                    buscarProductosConfiguracion({
                        nombre: null,
                        categoria: null,
                        subcategoria: null,
                        subsubcategoria: null,
                        codigo_barras: null
                    })
                );
            }

            return ok;
        } catch (error) {
            if (error?.response?.data?.msg) {
                await dispatch(setAlert(error.response.data.msg, 'danger'));
            } else {
                await dispatch(setAlert('Ocurrió un error al editar los productos', 'danger'));
            }
            return false;
        } finally {
            await dispatch(changeLoader(false));
        }
    };



    export const obtenerCodigoSiguienteProducto = () => async dispatch => {
        try {
            const res = await axios.get(
                `${process.env.REACT_APP_API_ROUTE}/facturas/codigo_producto`
            );

            if (res?.data?.success && res?.data?.codigo) {
                dispatch({
                    type: CONFIGURACION_PRODUCTOS.CODIGO_SIGUIENTE,
                    payload: res.data.codigo
                });
            } else {
                dispatch({
                    type: CONFIGURACION_PRODUCTOS.CODIGO_SIGUIENTE,
                    payload: null
                });
            }
        } catch (error) {
            dispatch({
                type: CONFIGURACION_PRODUCTOS.CODIGO_SIGUIENTE,
                payload: null
            });
        }
    };

    export const limpiarCodigoSiguienteProducto = () => dispatch => {
        dispatch({
            type: CONFIGURACION_PRODUCTOS.CODIGO_SIGUIENTE,
            payload: null
        });
    };



//Fin Prodcutos

// ================= ÁREAS =================

export const buscarAreasConfiguracion = () => async dispatch => {
    try {
        await dispatch(changeLoader(true));

        const res = await axios.get(
            `${process.env.REACT_APP_API_ROUTE}/configuracion/listar_areas`
        );

        const { areas } = res.data;

        await dispatch({
            type: CONFIGURACION_AREAS.BUSCAR,
            payload: areas || []
        });

        await dispatch(changeLoader(false));
    } catch (err) {
        console.error(err);
        await dispatch(changeLoader(false));
        dispatch(setAlert('Error al obtener el listado de áreas', 'danger'));
    }
};

export const crearAreaConfiguracion = ({ nombre }) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    const body = JSON.stringify({ nombre });

    try {
        await dispatch(changeLoader(true));

        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/configuracion/crear_area`,
            body,
            config
        );

        const { success, area, msg } = res.data;

        if (success && area) {
            await dispatch({
                type: CONFIGURACION_AREAS.AGREGAR,
                payload: area
            });

            dispatch(setAlert(msg || 'Área creada correctamente', 'success'));
        } else {
            dispatch(setAlert(msg || 'Error al crear el área', 'danger'));
        }

        await dispatch(changeLoader(false));
        return res.data;
    } catch (err) {
        console.error(err);
        await dispatch(changeLoader(false));
        dispatch(setAlert('Error al crear el área', 'danger'));
        return { success: false };
    }
};

export const eliminarAreaConfiguracion = ({ id, tipo }) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    const body = JSON.stringify({ id, tipo });

    try {
        await dispatch(changeLoader(true));

        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/configuracion/eliminar_area`,
            body,
            config
        );

        const { success, msg } = res.data;

        if (success) {
            await dispatch({
                type: CONFIGURACION_AREAS.ELIMINAR,
                payload: id
            });

            dispatch(setAlert(msg || 'Área eliminada correctamente', 'success'));
        } else {
            dispatch(setAlert(msg || 'Error al eliminar el área', 'danger'));
        }

        await dispatch(changeLoader(false));
        return res.data;
    } catch (err) {
        console.error(err);
        await dispatch(changeLoader(false));
        dispatch(setAlert('Error al eliminar el área', 'danger'));
        return { success: false };
    }
};

export const detallesAreaConfiguracion = (id) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    const body = JSON.stringify({ id });

    try {
        await dispatch(changeLoader(true));

        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/configuracion/detalles_area`,
            body,
            config
        );

        const { success, area } = res.data;

        if (success && area) {
            await dispatch({
                type: CONFIGURACION_AREAS.DETALLES,
                payload: area
            });
        }

        await dispatch(changeLoader(false));
        return res.data;
    } catch (err) {
        console.error(err);
        await dispatch(changeLoader(false));
        return { success: false };
    }
};

export const editarAreaConfiguracion = ({ id, nombre }) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    const body = JSON.stringify({ id, nombre });

    try {
        await dispatch(changeLoader(true));

        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/configuracion/editar_area`,
            body,
            config
        );

        const { success, area, msg } = res.data;

        if (success && area) {
            await dispatch({
                type: CONFIGURACION_AREAS.EDITAR,
                payload: area
            });
            dispatch(setAlert(msg || 'Área editada correctamente', 'success'));
        } else {
            dispatch(setAlert(msg || 'Error al editar el área', 'danger'));
        }

        await dispatch(changeLoader(false));
        return res.data;
    } catch (err) {
        console.error(err);
        await dispatch(changeLoader(false));
        dispatch(setAlert('Error al editar el área', 'danger'));
        return { success: false };
    }
};


// Organizadores
export const buscarOrganizadoresConfiguracion = (idArea) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    const body = JSON.stringify({ id: idArea });

    try {
        await dispatch(changeLoader(true));

        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/configuracion/listar_organizadores`,
            body,
            config
        );

        const { success, organizadores } = res.data;

        if (success) {
            await dispatch({
                type: CONFIGURACION_ORGANIZADORES.BUSCAR,
                payload: { organizadores: organizadores || [], id_area: idArea }
            });
        }

        await dispatch(changeLoader(false));
        return res.data;
    } catch (err) {
        console.error(err);
        await dispatch(changeLoader(false));
        dispatch(setAlert('Error al obtener los organizadores', 'danger'));
        return { success: false };
    }
};

// Crear organizador
export const crearOrganizadorConfiguracion = ({ id_area, nombre, idAreaVista }) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    // La API espera "id" = id_area
    const body = JSON.stringify({ id: id_area, nombre });

    try {
        await dispatch(changeLoader(true));

        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/configuracion/crear_organizador`,
            body,
            config
        );

        const { success, organizador, msg } = res.data;

        if (success && organizador) {
            await dispatch({
                type: CONFIGURACION_ORGANIZADORES.AGREGAR,
                payload: { organizador, idAreaVista }
            });
            dispatch(setAlert(msg || 'Organizador creado correctamente', 'success'));
        } else {
            dispatch(setAlert(msg || 'Error al crear el organizador', 'danger'));
        }

        await dispatch(changeLoader(false));
        return res.data;
    } catch (err) {
        console.error(err);
        await dispatch(changeLoader(false));
        dispatch(setAlert('Error al crear el organizador', 'danger'));
        return { success: false };
    }
};

// Detalles organizador
export const detallesOrganizadorConfiguracion = (id) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    const body = JSON.stringify({ id });

    try {
        await dispatch(changeLoader(true));

        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/configuracion/detalles_organizador`,
            body,
            config
        );

        const { success, organizador } = res.data;

        if (success && organizador) {
            await dispatch({
                type: CONFIGURACION_ORGANIZADORES.DETALLES,
                payload: organizador
            });
        }

        await dispatch(changeLoader(false));
        return res.data;
    } catch (err) {
        console.error(err);
        await dispatch(changeLoader(false));
        return { success: false };
    }
};

// Editar organizador
export const editarOrganizadorConfiguracion = ({ id, id_area, nombre, idAreaVista }) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    const body = JSON.stringify({ id, id_area, nombre });

    try {
        await dispatch(changeLoader(true));

        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/configuracion/editar_organizador`,
            body,
            config
        );

        const { success, organizador, msg } = res.data;

        if (success && organizador) {
            await dispatch({
                type: CONFIGURACION_ORGANIZADORES.EDITAR,
                payload: { organizador, idAreaVista }
            });
            dispatch(setAlert(msg || 'Organizador editado correctamente', 'success'));
        } else {
            dispatch(setAlert(msg || 'Error al editar el organizador', 'danger'));
        }

        await dispatch(changeLoader(false));
        return res.data;
    } catch (err) {
        console.error(err);
        await dispatch(changeLoader(false));
        dispatch(setAlert('Error al editar el organizador', 'danger'));
        return { success: false };
    }
};

// Eliminar organizador
export const eliminarOrganizadorConfiguracion = ({ id, tipo }) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    const body = JSON.stringify({ id, tipo }); // tipo = 1 ó 2

    try {
        await dispatch(changeLoader(true));

        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/configuracion/eliminar_organizador`,
            body,
            config
        );

        const { success, msg } = res.data;

        if (success) {
            await dispatch({
                type: CONFIGURACION_ORGANIZADORES.ELIMINAR,
                payload: id
            });
            dispatch(setAlert(msg || 'Organizador eliminado correctamente', 'success'));
        } else {
            dispatch(setAlert(msg || 'Error al eliminar el organizador', 'danger'));
        }

        await dispatch(changeLoader(false));
        return res.data;
    } catch (err) {
        console.error(err);
        await dispatch(changeLoader(false));
        dispatch(setAlert('Error al eliminar el organizador', 'danger'));
        return { success: false };
    }
};

// ============ UBICACIONES ============

// Listar ubicaciones por organizador
export const buscarUbicacionesConfiguracion = (idOrganizador) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    const body = JSON.stringify({ id: idOrganizador });

    try {
        await dispatch(changeLoader(true));

        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/configuracion/listar_ubicaciones`,
            body,
            config
        );

        const { success, ubicaciones } = res.data;

        if (success) {
            await dispatch({
                type: CONFIGURACION_UBICACIONES.BUSCAR,
                payload: { ubicaciones: ubicaciones || [], id_organizador: idOrganizador }
            });
        }

        await dispatch(changeLoader(false));
        return res.data;
    } catch (err) {
        console.error(err);
        await dispatch(changeLoader(false));
        dispatch(setAlert('Error al obtener las ubicaciones', 'danger'));
        return { success: false };
    }
};

// Crear ubicación
export const crearUbicacionConfiguracion = ({ id_organizador, nombre, idOrganizadorVista }) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    // La API espera "id" = id_organizador
    const body = JSON.stringify({ id: id_organizador, nombre });

    try {
        await dispatch(changeLoader(true));

        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/configuracion/crear_ubicacion`,
            body,
            config
        );

        const { success, ubicacion, msg } = res.data;

        if (success && ubicacion) {
            await dispatch({
                type: CONFIGURACION_UBICACIONES.AGREGAR,
                payload: { ubicacion, idOrganizadorVista }
            });
            dispatch(setAlert(msg || 'Ubicación creada correctamente', 'success'));
        } else {
            dispatch(setAlert(msg || 'Error al crear la ubicación', 'danger'));
        }

        await dispatch(changeLoader(false));
        return res.data;
    } catch (err) {
        console.error(err);
        await dispatch(changeLoader(false));
        dispatch(setAlert('Error al crear la ubicación', 'danger'));
        return { success: false };
    }
};

// Detalles ubicación
export const detallesUbicacionConfiguracion = (id) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    const body = JSON.stringify({ id });

    try {
        await dispatch(changeLoader(true));

        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/configuracion/detalles_ubicacion`,
            body,
            config
        );

        const { success, ubicacion } = res.data;

        if (success && ubicacion) {
            await dispatch({
                type: CONFIGURACION_UBICACIONES.DETALLES,
                payload: ubicacion
            });
        }

        await dispatch(changeLoader(false));
        return res.data;
    } catch (err) {
        console.error(err);
        await dispatch(changeLoader(false));
        return { success: false };
    }
};

// Editar ubicación
export const editarUbicacionConfiguracion = ({ id, id_organizador, nombre, idOrganizadorVista }) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    const body = JSON.stringify({ id, id_organizador, nombre });

    try {
        await dispatch(changeLoader(true));

        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/configuracion/editar_ubicacion`,
            body,
            config
        );

        const { success, ubicacion, msg } = res.data;

        if (success && ubicacion) {
            await dispatch({
                type: CONFIGURACION_UBICACIONES.EDITAR,
                payload: { ubicacion, idOrganizadorVista }
            });
            dispatch(setAlert(msg || 'Ubicación editada correctamente', 'success'));
        } else {
            dispatch(setAlert(msg || 'Error al editar la ubicación', 'danger'));
        }

        await dispatch(changeLoader(false));
        return res.data;
    } catch (err) {
        console.error(err);
        await dispatch(changeLoader(false));
        dispatch(setAlert('Error al editar la ubicación', 'danger'));
        return { success: false };
    }
};

// Eliminar ubicación (sin tipo)
export const eliminarUbicacionConfiguracion = (id) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    const body = JSON.stringify({ id });

    try {
        await dispatch(changeLoader(true));

        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/configuracion/eliminar_ubicacion`,
            body,
            config
        );

        const { success, msg } = res.data;

        if (success) {
            await dispatch({
                type: CONFIGURACION_UBICACIONES.ELIMINAR,
                payload: id
            });
            dispatch(setAlert(msg || 'Ubicación eliminada correctamente', 'success'));
        } else {
            dispatch(setAlert(msg || 'Error al eliminar la ubicación', 'danger'));
        }

        await dispatch(changeLoader(false));
        return res.data;
    } catch (err) {
        console.error(err);
        await dispatch(changeLoader(false));
        dispatch(setAlert('Error al eliminar la ubicación', 'danger'));
        return { success: false };
    }
};
export const buscarProveedoresProducto = (idProducto) => async (dispatch) => {
    const config = {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    };

    const body = new URLSearchParams({ id: idProducto }).toString();

    try {
        await dispatch(changeLoader(true));

        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/configuracion/proveedores_producto`,
            body,
            config
        );

        await dispatch({
            type: CONFIGURACION_PROVEEDORES_PRODUCTO.BUSCAR,
            payload: res.data?.productos || []
        });

        await dispatch(changeLoader(false));
    } catch (error) {
        await dispatch(changeLoader(false));

        await dispatch({ type: CONFIGURACION_PROVEEDORES_PRODUCTO.ERROR });

        dispatch(setAlert(
            error?.response?.data?.msg || 'Error al consultar proveedores del producto',
            'danger'
        ));
    }
};

export const limpiarProveedoresProducto = () => async (dispatch) => {
    dispatch({ type: CONFIGURACION_PROVEEDORES_PRODUCTO.LIMPIAR });
};

//Unidades//
export const buscarUnidades = () => async (dispatch) => {
    try {
        await dispatch(changeLoader(true));

        const res = await axios.get(
            `${process.env.REACT_APP_API_ROUTE}/configuracion/listar_unidades`
        );

        await dispatch({
            type: CONFIGURACION_UNIDADES.BUSCAR,
            payload: res.data?.unidades || []
        });

        await dispatch(changeLoader(false));
    } catch (error) {
        await dispatch(changeLoader(false));

        await dispatch({ type: CONFIGURACION_UNIDADES.ERROR });

        dispatch(setAlert(
            error?.response?.data?.msg || 'Error al consultar unidades',
            'danger'
        ));
    }
};

export const limpiarUnidades = () => async (dispatch) => {
    await dispatch({ type: CONFIGURACION_UNIDADES.LIMPIAR });
};

export const crearUnidad = ({ nombre, descripcion }) => async (dispatch) => {
    const config = {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    };

    const body = new URLSearchParams({
        nombre: (nombre || '').trim(),
        descripcion: (descripcion || '').trim()
    }).toString();

    try {
        await dispatch(changeLoader(true));

        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/configuracion/crear_unidad`,
            body,
            config
        );

        await dispatch({
            type: CONFIGURACION_UNIDADES.CREAR,
            payload: res.data?.unidad || null
        });

        dispatch(setAlert(
            res.data?.msg || 'Unidad creada correctamente',
            'success'
        ));

        await dispatch(changeLoader(false));

        return true;
    } catch (error) {
        await dispatch(changeLoader(false));

        await dispatch({ type: CONFIGURACION_UNIDADES.CREAR_ERROR });

        dispatch(setAlert(
            error?.response?.data?.msg || 'Error al crear unidad',
            'danger'
        ));

        return false;
    }
};

export const editarUnidad = ({ id, nombre, descripcion }) => async (dispatch) => {
    const config = {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    };

    const body = new URLSearchParams({
        id: id || '',
        nombre: (nombre || '').trim(),
        descripcion: (descripcion || '').trim()
    }).toString();

    try {
        await dispatch(changeLoader(true));

        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/configuracion/editar_unidad`,
            body,
            config
        );

        await dispatch({
            type: CONFIGURACION_UNIDADES.EDITAR,
            payload: res.data?.unidad || null
        });

        dispatch(setAlert(
            res.data?.msg || 'Unidad editada correctamente',
            'success'
        ));

        await dispatch(changeLoader(false));
        return true;
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: CONFIGURACION_UNIDADES.EDITAR_ERROR });

        dispatch(setAlert(
            error?.response?.data?.msg || 'Error al editar unidad',
            'danger'
        ));

        return false;
    }
};

export const obtenerUnidadesProducto = (id) => async (dispatch) => {
    const config = {
        headers: { 'Content-Type': 'application/json' }
    };

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/configuracion/obtener_unidades_producto`,
            { id },
            config
        );
        await dispatch(changeLoader(false));
        return Array.isArray(res.data?.unidades) ? res.data.unidades : [];
    } catch (error) {
        await dispatch(changeLoader(false));
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
        return [];
    }
};

export const editarUnidadesProducto = (id, unidades) => async (dispatch) => {
    const config = {
        headers: { 'Content-Type': 'application/json' }
    };

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/configuracion/editar_unidades_producto`,
            { id, unidades },
            config
        );
        await dispatch(changeLoader(false));

        if (res?.data?.msg) {
            await dispatch(setAlert(res.data.msg, 'success'));
        }

        return res.data?.success === true;
    } catch (error) {
        await dispatch(changeLoader(false));
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
        return false;
    }
};

export const eliminarUnidad = (id) => async (dispatch) => {
    const config = {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    };

    const body = new URLSearchParams({
        id: id || ''
    }).toString();

    try {
        await dispatch(changeLoader(true));

        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/configuracion/eliminar_unidad`,
            body,
            config
        );

        await dispatch({
            type: CONFIGURACION_UNIDADES.ELIMINAR,
            payload: id || ''
        });

        dispatch(setAlert(
            res.data?.msg || 'Unidad eliminada correctamente',
            'success'
        ));

        await dispatch(changeLoader(false));
        return true;
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: CONFIGURACION_UNIDADES.ELIMINAR_ERROR });

        dispatch(setAlert(
            error?.response?.data?.msg || 'Error al eliminar unidad',
            'danger'
        ));

        return false;
    }
};

//Paquetes
export const buscarPaquetes = (filtros = {}) => async (dispatch) => {
    const config = {
        headers: { 'Content-Type': 'application/json' }
    };

    const body = JSON.stringify({
        busqueda: filtros.busqueda || null
    });

    try {
        await dispatch(changeLoader(true));

        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/configuracion/listar_paquetes`,
            body,
            config
        );

        await dispatch({
            type: CONFIGURACION_PAQUETES.BUSCAR,
            payload: res.data?.paquetes || []
        });

        await dispatch(changeLoader(false));
    } catch (error) {
        await dispatch(changeLoader(false));

        await dispatch({ type: CONFIGURACION_PAQUETES.ERROR });

        dispatch(setAlert(
            error?.response?.data?.msg || 'Error al consultar paquetes',
            'danger'
        ));
    }
};

export const limpiarPaquetes = () => async (dispatch) => {
    await dispatch({ type: CONFIGURACION_PAQUETES.LIMPIAR });
};

export const obtenerPaquete = (id) => async (dispatch) => {
    const config = {
        headers: { 'Content-Type': 'application/json' }
    };

    try {
        await dispatch(changeLoader(true));

        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/configuracion/detalles_paquete`,
            { id },
            config
        );

        await dispatch(changeLoader(false));

        if (!res.data?.success) {
            dispatch(setAlert(res.data?.msg || 'No se pudo consultar el paquete', 'danger'));
            return null;
        }

        await dispatch({
            type: CONFIGURACION_PAQUETES.DETALLE,
            payload: res.data?.paquete || null
        });

        return res.data?.paquete || null;
    } catch (error) {
        await dispatch(changeLoader(false));

        dispatch(setAlert(
            error?.response?.data?.msg || 'Error al consultar el paquete',
            'danger'
        ));

        return null;
    }
};

export const limpiarPaqueteDetalle = () => async (dispatch) => {
    await dispatch({ type: CONFIGURACION_PAQUETES.LIMPIAR_DETALLE });
};

export const crearPaquete = ({ nombre, descripcion, codigo, precio, precio_compra, iva, productos }) => async (dispatch) => {
    const config = {
        headers: { 'Content-Type': 'application/json' }
    };

    const body = JSON.stringify({
        nombre,
        descripcion: descripcion || null,
        codigo,
        precio,
        precio_compra: precio_compra || 0,
        iva: iva || false,
        productos: Array.isArray(productos) ? productos : []
    });

    try {
        await dispatch(changeLoader(true));

        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/configuracion/crear_paquete`,
            body,
            config
        );

        await dispatch(changeLoader(false));

        if (!res.data?.success) {
            dispatch(setAlert(res.data?.msg || 'No se pudo crear el paquete', 'danger'));
            return null;
        }

        await dispatch({
            type: CONFIGURACION_PAQUETES.CREAR,
            payload: res.data?.paquete || null
        });

        dispatch(setAlert(res.data?.msg || 'Paquete creado correctamente', 'success'));

        return res.data?.paquete || null;
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: CONFIGURACION_PAQUETES.CREAR_ERROR });

        dispatch(setAlert(
            error?.response?.data?.msg || 'Error al crear el paquete',
            'danger'
        ));

        return null;
    }
};

export const editarPaquete = ({ id, nombre, descripcion, codigo, precio, precio_compra, iva, productos }) => async (dispatch) => {
    const config = {
        headers: { 'Content-Type': 'application/json' }
    };

    const body = JSON.stringify({
        id,
        nombre,
        descripcion: descripcion || null,
        codigo,
        precio,
        precio_compra: precio_compra || 0,
        iva: iva || false,
        productos: Array.isArray(productos) ? productos : []
    });

    try {
        await dispatch(changeLoader(true));

        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/configuracion/editar_paquete`,
            body,
            config
        );

        await dispatch(changeLoader(false));

        if (!res.data?.success) {
            dispatch(setAlert(res.data?.msg || 'No se pudo editar el paquete', 'danger'));
            return null;
        }

        await dispatch({
            type: CONFIGURACION_PAQUETES.EDITAR,
            payload: res.data?.paquete || null
        });

        dispatch(setAlert(res.data?.msg || 'Paquete editado correctamente', 'success'));

        return res.data?.paquete || null;
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: CONFIGURACION_PAQUETES.EDITAR_ERROR });

        dispatch(setAlert(
            error?.response?.data?.msg || 'Error al editar el paquete',
            'danger'
        ));

        return null;
    }
};

export const eliminarPaquete = (id) => async (dispatch) => {
    const config = {
        headers: { 'Content-Type': 'application/json' }
    };

    try {
        await dispatch(changeLoader(true));

        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/configuracion/eliminar_paquete`,
            { id },
            config
        );

        await dispatch(changeLoader(false));

        if (!res.data?.success) {
            dispatch(setAlert(res.data?.msg || 'No se pudo eliminar el paquete', 'danger'));
            return false;
        }

        await dispatch({
            type: CONFIGURACION_PAQUETES.ELIMINAR,
            payload: id || ''
        });

        dispatch(setAlert(res.data?.msg || 'Paquete eliminado correctamente', 'success'));

        return true;
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: CONFIGURACION_PAQUETES.ELIMINAR_ERROR });

        dispatch(setAlert(
            error?.response?.data?.msg || 'Error al eliminar el paquete',
            'danger'
        ));

        return false;
    }
};